import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field, NativeSelect } from "@/components/visit/VisitBits";
import ValuationBreakdown from "@/components/visit/ValuationBreakdown";
import { CONSTRUCTION_TYPES, PROPERTY_TYPES, VALUATION_INPUTS, applyValuation, setPath } from "@/lib/visitSchema";

const DIRS = [["north", "North"], ["south", "South"], ["east", "East"], ["west", "West"]];
const NUMS = [["plot_length_ft", "Plot length (ft)"], ["plot_width_ft", "Plot width (ft)"], ["built_up_area_sqft", "Built-up area (sq ft)"], ["year_of_construction", "Year of construction"]];
const RATES = [["plot_land_rate_per_sqft", "Plot land rate (₹/sq ft)"], ["construction_cost_per_sqft", "Cost of construction (₹/sq ft)"]];

export default function BasicDetailsStep({ form, setForm }) {
  const set = (path) => (v) => setForm((prev) => {
    const next = setPath(prev, path, v?.target ? v.target.value : v);
    return VALUATION_INPUTS.includes(path) ? applyValuation(next) : next;
  });
  const setManualAmount = (e) => setForm((prev) => ({ ...prev, valuation_amount_inr: e.target.value, valuation_manual: true }));
  const resetAmount = () => setForm((prev) => applyValuation({ ...prev, valuation_manual: false }));
  return (
    <div className="space-y-4" data-testid="visit-step-basic-panel">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Field label="Property address" className="md:col-span-2"><Textarea rows={2} value={form.property_address} onChange={set("property_address")} data-testid="visit-address" /></Field>
        <Field label="Owner name"><Input value={form.owner_name} onChange={set("owner_name")} data-testid="visit-owner" /></Field>
        <Field label="Property type"><NativeSelect value={form.property_type} onChange={set("property_type")} options={PROPERTY_TYPES} placeholder="Select property type" testId="visit-property-type" /></Field>
        <Field label="Construction type"><NativeSelect value={form.construction_type} onChange={set("construction_type")} options={CONSTRUCTION_TYPES} placeholder="Select structure" testId="visit-construction-type" /></Field>
        <Field label="Number of floors"><Input type="number" min="0" value={form.floors} onChange={set("floors")} data-testid="visit-floors" /></Field>
      </div>
      <div>
        <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2">Boundaries & dimensions</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {DIRS.map(([d, label]) => (
            <Field key={d} label={label}><Input value={form[`boundary_${d}`]} onChange={set(`boundary_${d}`)} placeholder="e.g. 25ft road" data-testid={`visit-boundary-${d}`} /></Field>
          ))}
          {NUMS.map(([k, label]) => (
            <Field key={k} label={label}><Input type="number" min="0" inputMode="decimal" value={form[k]} onChange={set(k)} data-testid={`visit-${k}`} /></Field>
          ))}
        </div>
      </div>
      <div>
        <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-2">Rates & valuation</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {RATES.map(([k, label]) => (
            <Field key={k} label={label}><Input type="number" min="0" inputMode="decimal" value={form[k]} onChange={set(k)} placeholder="₹ per sq ft" data-testid={`visit-${k}`} /></Field>
          ))}
          <div className="md:col-span-2"><ValuationBreakdown form={form} onReset={resetAmount} /></div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Field label="Building bylaws notes"><Textarea rows={2} value={form.bylaws_notes} onChange={set("bylaws_notes")} data-testid="visit-bylaws" /></Field>
        <Field label={form.valuation_manual ? "Valuation amount (₹) · manual" : "Valuation amount (₹) · auto-calculated"}>
          <Input type="number" min="0" inputMode="decimal" value={form.valuation_amount_inr} onChange={setManualAmount} placeholder="Fills in from the calculator" data-testid="visit-amount" />
        </Field>
      </div>
    </div>
  );
}
